import { Fragment, useState } from 'react';
import {
    SimpleForm, useTranslate, Toolbar, SaveButton,
    Button, ReferenceArrayInput,
    useNotify, useRefresh, AutocompleteArrayInput,
    TextInput,
    minLength,
    maxLength,
    required,
} from 'react-admin';
import axios from 'axios';
import { makeStyles } from '@mui/styles';
import { Link } from '@material-ui/icons';
import { Dialog, DialogContent, DialogTitle } from '@material-ui/core';
import { ViewTitle } from '../../components';
import { Cancel } from '@mui/icons-material';
import handleError from '../../components/handleError';

const useStyles = makeStyles((theme) => ({
    toolbar: {
        display: 'flex',
    },
    spacer: {
        flex: 1,
    },
    buttonMarginLeft: {
        marginLeft: 10
    },
    flexBox: {
        width: 'auto',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center'
    },
    inputMarginLeft: {
        marginLeft: 20
    },
    border: {
        border: '1px solid #6b489d'
    }
}));

const Validate = (values) => {
    const errors = {};
    if (!values.rapSerialNumber) errors.rapSerialNumber = 'ra.validation.required';
    return errors;
};


const AssociateRapToPod = ({ pod, permissions }) => {

    const translate = useTranslate();
    const [showDialog, setShowDialog] = useState(false);
    const notify = useNotify();
    const refresh = useRefresh();

    const AssociateRap = async (data) => {

        try {
            const options = {
                headers: {},
            };

            const resolvedPodId = pod ?? data?.id;
            if (!resolvedPodId) {
                notify(translate("app.pods.associateRap.missingPodId", { _: "Missing pod id" }), { type: "error" });
                return;
            }

            const sendData = {
                serialNumber: data.rapSerialNumber,
                pod: resolvedPodId,
            };


            const token = localStorage.getItem('token');
            options.headers.Authorization = `Bearer ${token}`;

            const res = await axios.post(`/api/v1/rap/associate`, sendData, options);
            if (res.status !== 200) {
                notify(translate('app.pods.associateRap.errorMessage'), { type: 'error' });
            }
            else {
                notify(translate('app.pods.associateRap.successMessage'), { type: 'success' });
                handleCloseClick();
                refresh();
            };
        }
        catch (error) {
            handleError(error, notify);
        }
    }


    const handleClick = () => {
        setShowDialog(true);
    };

    const handleCloseClick = () => {
        setShowDialog(false);
    };

    const fullNameField = choice => `${choice.firstname} ${choice.lastname}`;
    const CreateToolbar = (props) => {
        const classes = useStyles();
        const translate = useTranslate();
        return (
            <Toolbar className={classes.toolbar}>
                <Button label="ra.action.cancel" size="medium" onClick={handleCloseClick} className={classes.border} >
                    <Cancel />
                </Button>
                <SaveButton label={translate('app.buttons.send')} className={classes.buttonMarginLeft} />
            </Toolbar>
        );
    };


    return (
        <Fragment>
            <Button label={translate('app.pods.associateRap.button')} onClick={handleClick}><Link /></Button>
            <Dialog
                fullWidth
                open={showDialog}
                onClose={handleCloseClick}
                aria-label={translate('app.pods.associateRap.title')}
            >
                <DialogTitle><ViewTitle label={translate('app.pods.associateRap.title')} icon={Link} /></DialogTitle>
                <DialogContent>
                    <SimpleForm toolbar={<CreateToolbar />}
                        onSubmit={AssociateRap} >
                        <TextInput
                            source="rapSerialNumber"
                            label={translate('app.pods.associateRap.input')}
                            validate={[
                                required(),
                                minLength(5),
                                maxLength(15),
                            ]}
                        />
                    </SimpleForm>
                </DialogContent>
            </Dialog>
        </Fragment>
    );
};

export default AssociateRapToPod;

